/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';
import { getContentItemForSlotByName } from '@/data/utils/getContentItemForSlotByName';

export const getHomePage = (props: IncomingContent): Layout => ({
		name: 'HomeStack',
		slots: {
			header: [{ name: 'Header', id: 'header' }],
			first: getContentItemForSlotByName(props, 'first'),
			second: getContentItemForSlotByName(props, 'second'),
			footer: [{ name: 'Footer', id: 'footer' }],
		},
	});
